enum StartNodeType {
    STOP = 'P',
    CROSSROAD = 'X',
    MUNICIPALITY_BORDER = '-',
    DISABLED = 'E',
}

export default StartNodeType;
